export const isValidEmail = (email) => {
  var re = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9\-.]+$)/;
  return re.test(email);
};
